import { EventEmitter, Input, Output, Directive, Component } from '@angular/core';

import { BaseEntity } from '@bndes/bndes-angular-utils';

import {EstiloFormularioEnum} from '@smdapp/shared/enums/estilo-formulario.enum'

import {ErroApp} from '@smdapp/shared/models/erro-app.model'

import { Services,  } from '@smdapp/shared';

import { ConfirmacaoModalService } from '../confirmacao-modal';

import { FormGroupBase } from './form-group-base';
import { DataObserver } from '@smdlib/statex/@angular';

@Directive()
export abstract class FormBase<T extends FormGroupBase, E extends BaseEntity> extends DataObserver
{
    formulario: T;

    private _estaSalvando = false;
    private _mensagemAviso: string = '';
    private _item: E;
    private _estiloFormulario: EstiloFormularioEnum;

    @Output() salvar = new EventEmitter<E>();
    @Output() salvarIncluirOutro = new EventEmitter<E>();
    @Output() ativar = new EventEmitter<E>();
    @Output() desativar = new EventEmitter<E>();
    @Output() exibirFormularioAlteracao= new EventEmitter<any>();
    @Output() excluir = new EventEmitter<any>();
    @Output() voltar = new EventEmitter<any>();

    public abstract clonarEAssociar(original: E, formData: any): E;

    public getFormulario(): T
    {
        return this.formulario;
    }

    @Input() set item(item: E)
    {
        this._item = item;
        if (this._item != null)
        {
            this.getFormulario().formGroup.patchValue(this._item);
        }
    }
    get item(): E { return this._item; }

    @Input() set mensagemAviso(msg: any)
    {
        this._mensagemAviso = msg;
    }
    get mensagemAviso(): any { return this._mensagemAviso; }

    @Input() set estaSalvando(salvando: boolean)
    {
        this._estaSalvando = salvando;
    }
    get estaSalvando(): boolean { return this._estaSalvando; }

    @Input() set estiloFormulario(estilo: EstiloFormularioEnum)
    {
        this._estiloFormulario = estilo;
    }
    get estiloFormulario(): EstiloFormularioEnum { return this._estiloFormulario; }

    constructor(protected  svc: Services, protected confirmacaoService: ConfirmacaoModalService)
    {
        super();
    }

    public estaAlterando(): boolean
    {
        return this._estiloFormulario == EstiloFormularioEnum.Alteracao;
    }

    public estaIncluindo(): boolean
    {
        return this._estiloFormulario == EstiloFormularioEnum.Inclusao;
    }

    public estaVisualizando(): boolean
    {
        return this._estiloFormulario == EstiloFormularioEnum.Visualicacao;
    }

    public onFormSalvar()
    {
        if (!this.salvar)
        {
            this.svc.logger.warn("Ação não executada. Favor definir um evento para a propriedade (salvar)");
            return;
        }
        return this.salvarAux(this.salvar);
    }

    public onFormSalvarIncluirOutro()
    {
        if (!this.salvarIncluirOutro)
        {
            this.svc.logger.warn("Ação não executada. Favor definir um evento para a propriedade (salvarIncluirOutro)");
            return;
        }
        return this.salvarAux(this.salvarIncluirOutro);
    }

    public onFormAtivar()
    {
        if (!this.ativar)
        {
            this.svc.logger.warn("Ação não executada. Favor definir um evento para a propriedade (ativar)");
            return;
        }
        return this.ativar.emit(this._item);
    }

    public onFormDesativar()
    {
        if (!this.desativar)
        {
            this.svc.logger.warn("Ação não executada. Favor definir um evento para a propriedade (desativar)");
            return;
        }
        return this.desativar.emit(this._item);
    }

    public onFormExibirFormularioAlteracao()
    {
        if (!this.exibirFormularioAlteracao)
        {
            this.svc.logger.warn("Ação não executada. Favor definir um evento para a propriedade (exibirFormularioAlteracao)");
            return;
        }
        this.exibirFormularioAlteracao.emit();
    }

    public onFormExcluir()
    {
        if (!this.excluir)
        {
            this.svc.logger.warn("Ação não executada. Favor definir um evento para a propriedade (excluir)");
            return;
        }
        this.excluir.emit();
    }

    public onFormVoltar()
    {
        if (!this.voltar)
        {
            this.svc.logger.warn("Ação não executada. Favor definir um evento para a propriedade (voltar)");
            return;
        }
        this.voltar.emit()
    }

    private salvarAux = (evento) =>
    {
        if (!evento)
        {
            return;
        }
        const itemEditado = this.clonarEAssociar(this._item, this.formulario.valores);
        evento.emit(itemEditado);
    }

    protected alertarErro(titulo: string, cabecalho: string, err: any)
    {
        if (err instanceof ErroApp)
        {
            //this.svc.bnAlertService.alertaErro(titulo, err.cabecalho + ' ' + cabecalho, err.listaComentarios);
            this.svc.bnAlertService.alertaErro(titulo, err.cabecalho + ' ' + cabecalho, this.svc.errorHandlerService.createErrorApp(err));
            return;
        }
        if (err == null)
        {
            this.svc.bnAlertService.alertaErro(titulo, cabecalho);
            return;
        }
        this.svc.bnAlertService.alertaErro(titulo, cabecalho, err);
    }
}
